import { useSelector } from 'react-redux';

import {
    selectHasCameraMutePermission,
    selectHasDesktopMutePermission,
    selectHasMicrophoneMutePermission,
    selectHasRecordingMutePermission,
} from '../../../../pages/call/features/permissions';
import { selectIsPermissionsExtendedEnabled } from '../../../../pages/call/selectors';

export function useModerationPermissionsExtended() {
    const isPermissionsExtendedEnabled = useSelector(selectIsPermissionsExtendedEnabled);
    const hasMicrophoneMutePermission = useSelector(selectHasMicrophoneMutePermission);
    const hasRecordingMutePermission = useSelector(selectHasRecordingMutePermission);
    const hasDesktopMutePermission = useSelector(selectHasDesktopMutePermission);
    const hasCameraMutePermission = useSelector(selectHasCameraMutePermission);
    const hasAnyModerationPermissionWithoutMicrophone =
        hasRecordingMutePermission || hasDesktopMutePermission || hasCameraMutePermission;

    return {
        isPermissionsExtendedEnabled,
        hasCameraMutePermission,
        hasMicrophoneMutePermission,
        hasRecordingMutePermission,
        hasDesktopMutePermission,
        hasAnyModerationPermissionWithoutMicrophone,
        hasAnyModerationPermission: hasAnyModerationPermissionWithoutMicrophone || hasMicrophoneMutePermission,
    };
}
